// 3rd party pacakge imports
import { Route, Routes } from 'react-router-dom';

// Layout imports for routes
import AppLayout from './layout/AppLayout';
import ProtectedLayout from './layout/ProtectedLayout';

// Route protection imports
import PublicRoute from './routes/PublicRoute';
import ProtectedRoute from './routes/ProtectedRoute';

// Component imports for pages
import Login from './pages/public/Login';
import Home from './pages/private/Home';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

function App() {

  // useeffect to disable unwanted browser defaults
  useEffect(() => {
    window.addEventListener('contextmenu', e => e.preventDefault());
    window.addEventListener('unhandledrejection', e => e.preventDefault());
    window.addEventListener('drop', e => e.preventDefault());
    window.addEventListener('drag', e => e.preventDefault());
    window.addEventListener('dragover', e => e.preventDefault());
    window.addEventListener('dragenter', e => e.preventDefault());
    window.addEventListener('dragexit', e => e.preventDefault());
    window.addEventListener('dragstart', e => e.preventDefault());
    window.addEventListener('dragleave', e => e.preventDefault());
    window.addEventListener('dragend', e => e.preventDefault());
  }, []);

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {/* public route - no login required */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Protected Route - login required */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<ProtectedLayout />}>
            <Route path="/" element={<ProtectedLayout />}>
              <Route element={<Home />}>
                <Route index element={null} />
                <Route path="people" element={null} />
                <Route path="files" element={null} />
                <Route path="manage-forms" element={null} />
                <Route path="acknowledgement" element={null} />
                <Route path="archive" element={null} />
                <Route path="gap-analysis" element={null} />
                <Route path="connection-settings" element={null} />
                <Route path="search-analytics" element={null} />
                <Route path="knowledge-gap" element={null} />
                <Route path="dashboard-charts" element={null} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
